import {PageHeader} from '../layout/PageHeader'

const ConnectorsSettingsWrapper = () => {
  return (
    <>
      <PageHeader
        eyebrow='Настройки'
        title='Коннекторы'
        description='Подключение брокерских счетов и управление ключами доступа.'
      />
      <connectors-settings-page />
    </>
  )
}

export {ConnectorsSettingsWrapper}
